import { useContext } from "react";
import { Alert, CircularProgress } from "@mui/material";
import { ParagraphText } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { QRICON } from "../../../assets/icons/icon";
import styles from "./styles.module.css";

const AppCollectPayment = ({
  status,
  hasRaastDetail,
  onViewQR,
  onGetQR,
  onAddContact,
  customMessage,
  customLinkText,
  customIcon,
  loading,
  contactValue = "",
  isSale,
  visible = true,
}) => {
  const [I18n] = useContext(LanguageContext);

  const message =
    customMessage && status !== "Unpaid"
      ? customMessage
      : status === "Paid"
        ? I18n.collect_payment_via_QR_or_bank_transfer
        : I18n.transaction_will_be_added_to_sales_and_contact;

  const linkText =
    customLinkText && status !== "Unpaid"
      ? customLinkText
      : status === "Paid"
        ? hasRaastDetail
          ? I18n.view_qr
          : I18n.get_qr
        : contactValue || I18n.add_contact;

  const handleLinkClick = () => {
    if (status === "Paid" && isSale) {
      hasRaastDetail ? onViewQR?.() : onGetQR?.();
    } else {
      onAddContact?.();
    }
  };

  const hasContent = !(status === "Paid" && !isSale && !hasRaastDetail && !customMessage);
  const isShown = visible && hasContent;
  const isRtlMessage = /[؀-ۿ]/.test(message || "");

  return (
    <div
      className={`${styles.reveal} ${isShown ? styles.revealVisible : ""}`}
      aria-hidden={!isShown}
    >
      <div className={styles.revealInner}>
        {hasContent ? (
          <Alert
            className={`${styles.paymentStatusAlert} paymentStatusAlert`}
            icon={
              customIcon ? (
                customIcon
              ) : status === "Paid" ? (
                <QRICON width={18} height={18} />
              ) : (
                <></>
              )
            }
          >
            {/* Urdu message: rtl so the link always follows the sentence. Without it a Latin
                contact name ("Adeel") jumped to the other end of the line from "نمبر شامل کریں".
                Kept left-aligned like before; dir comes from the message (it can start with "QR").
                The link is its own ltr run: some link keys (view_qr "دیکھیں QR") are written for
                left-to-right buttons elsewhere, so they must render the same way here. */}
            <ParagraphText
              className="fontSize12 newFontColor"
              dir={isRtlMessage ? "rtl" : "ltr"}
              style={{ textAlign: "left" }}
            >
              {message}
              <span
                className={`${styles.alertLink} alertLink`}
                dir="ltr"
                style={isRtlMessage ? { marginRight: "0.313rem" } : { marginLeft: "0.313rem" }}
                onClick={handleLinkClick}
              >
                {loading ? (
                  <CircularProgress
                    size={8}
                    sx={{ color: "var(--mainColor)" }}
                  />
                ) : (
                  linkText
                )}
              </span>
            </ParagraphText>
          </Alert>
        ) : null}
      </div>
    </div>
  );
};

export default AppCollectPayment;
